import { Chip } from '@material-ui/core';

import { ReactComponent as BagOutlineIcon } from 'assets/images/icons/BagOutlineIcon.svg';
import { useAuditableChipLang } from './useAuditableChipLang';

import makeClasses from './AuditableChip.style';

import type { ChipProps } from '@material-ui/core';

export function AuditableChip(props: Props) {
  const { show, classes = {}, ...extraProps } = props;
  if (!Boolean(show)) return null;

  const lang = useAuditableChipLang();

  const _classes = makeClasses();

  return (
    <Chip
      role='status'
      aria-live='polite'
      label={lang.label}
      icon={<BagOutlineIcon />}
      classes={{
        root: _classes.root,
        icon: _classes.icon,
        label: _classes.label,
        ...classes,
      }}
      {...extraProps}
    />
  );
}

interface Props extends ChipProps {
  show?: boolean;
}
